import { Accordion } from "./accordion";

//App.Common.Faq
export class Faq {
    static init(): void {
        Accordion.init();
        window.addEventListener("hashchange", () => {
            Faq.openFaqWithHash();
        });
        Faq.openFaqWithHash();

        document.getElementById("faq-toggle")?.addEventListener("click", () => {
            Faq.handleToggle();
        });

        // Search on click
        document.getElementById("faq-search-form")?.addEventListener("submit", (event) => {
            event.preventDefault();
            Faq.search();
        });
        Faq.attachImageEvent();
    }
    static attachImageEvent(): void {
        document.querySelectorAll("details").forEach((e) => {
            Faq.attachEventToggle(e);
        });
    }
    static attachEventToggle(element: HTMLElement) {
        element.addEventListener("toggle", (event: Event) => {
            const eventTarget = event.target as HTMLElement;
            if (eventTarget.hasAttribute("open")) {
                eventTarget.querySelectorAll("img").forEach((img: HTMLImageElement) => {
                    if (!img.src) {
                        img.src = img.getAttribute("data-src");
                    }
                });
            }
        });
    }

    static openFaqWithHash(): void {
        const hash = window.location.hash.substring(1);
        Faq.closeAllFaq();
        if (hash.length > 0) {
            if (document.getElementById(hash)) {
                document.getElementById(hash).setAttribute("open", "true");
            }
        }
    }

    static closeAllFaq(): void {
        document.querySelectorAll("details").forEach((e) => {
            if (e.hasAttribute("open")) {
                e.removeAttribute("open");
            }
        });
    }

    static openAllFaq(): void {
        document.querySelectorAll("details").forEach((e) => {
            e.setAttribute("open", "true");
        });
    }


    static handleToggle(): void {
        const toggleButton = document.getElementById("faq-toggle");
        const actualText = toggleButton.innerText.trim();
        const openText = toggleButton.getAttribute("data-togglebuttonopen");
        const closeText = toggleButton.getAttribute("data-togglebuttonclose");
        if (actualText !== openText) {
            toggleButton.innerText = openText;
            Faq.closeAllFaq();
        } else {
            toggleButton.innerText = closeText;
            Faq.openAllFaq();
        }
    }

    static search(): void {
        const keywordObj = <HTMLInputElement>document.getElementById("faq-search-keyword");
        const keyword: string = keywordObj.value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const contextContainer = document.getElementById("faq-text");
        // Reset
        contextContainer.innerHTML = contextContainer.innerHTML.replace(/<(\/){0,1}mark>/g, "");

        if (keyword.length > 0) {
            const highlighter = new InstantSearch(contextContainer, [keyword]);
            highlighter.highlight();
        }

        const numberOfSearchResults: number = document.querySelectorAll("mark").length;
        const faqSearchResults = document.getElementById("faq-search-results");

        faqSearchResults.innerText = numberOfSearchResults.toString() + " "
            + faqSearchResults.getAttribute(numberOfSearchResults === 1 ? "data-searchresultsingural" : "data-searchresultplural");
        faqSearchResults.removeAttribute("aria-hidden");

        document.querySelectorAll("details").forEach((e) => {
            Faq.attachEventToggle(e);
            if (e.querySelectorAll("mark").length > 0) {
                e.setAttribute("open", "true");
            } else {
                e.removeAttribute("open");
            }
        });

        if (numberOfSearchResults > 0) {
            document.querySelector("mark").closest("details")?.querySelector("summary")?.focus();
        }
    }
}

export class InstantSearch {

    protected m_container: Node;
    protected m_keywords: string[];

    constructor(container: Node, tokens: string[]) {
        this.iterator = this.iterator.bind(this);
        this.checkAndReplace = this.checkAndReplace.bind(this);
        this.highlight = this.highlight.bind(this);
        this.m_container = container;
        this.m_keywords = tokens || ["test"];
    }

    protected checkAndReplace(node: Node) {
        let nodeVal: string = node.nodeValue;
        const parentNode: Node = node.parentNode;
        let textNode: Text = null;

        for (let i = 0, j = this.m_keywords.length; i < j; i++) {
            const textToHighlight: string = this.m_keywords[i];

            let isFirst = true;
            // eslint-disable-next-line no-constant-condition
            while (true) {
                const foundIndex: number = nodeVal.toLowerCase().indexOf(textToHighlight.toLowerCase());

                if (foundIndex < 0) {
                    if (isFirst)
                        break;

                    if (nodeVal) {
                        textNode = document.createTextNode(nodeVal);
                        parentNode.insertBefore(textNode, node);
                    }
                    parentNode.removeChild(node);
                    break;
                }
                isFirst = false;


                const begin: string = nodeVal.substring(0, foundIndex);
                const matched: string = nodeVal.substr(foundIndex, textToHighlight.length);

                if (begin) {
                    textNode = document.createTextNode(begin);
                    parentNode.insertBefore(textNode, node);
                }

                const span: HTMLElement = document.createElement("mark");
                span.appendChild(document.createTextNode(matched));
                parentNode.insertBefore(span, node);

                nodeVal = nodeVal.substring(foundIndex + textToHighlight.length);
            }
        }
    }

    protected iterator(p: Node) {
        if (p == null)
            return;
        const children: Node[] = Array.prototype.slice.call(p.childNodes);
        if (children.length) {
            for (let i = 0; i < children.length; i++) {
                const cur: Node = children[i];
                if (cur.nodeType === Node.TEXT_NODE) {
                    this.checkAndReplace(cur);
                }
                else if (cur.nodeType === Node.ELEMENT_NODE) {
                    this.iterator(cur);
                }
            }
        }
    }
    public highlight() {
        this.iterator(this.m_container);
    }
}
